module.exports = ".depositor-sign{\r\n    display: -ms-grid;\r\n    display: grid;\r\n    height: 100%;\r\n    -webkit-box-align: end;\r\n        -ms-flex-align: end;\r\n            align-items: end;\r\n    -ms-flex-line-pack: end;\r\n        align-content: end;\r\n}\r\n\r\n.authority-sign{\r\n    padding: 50px 0px 0px;\r\n    display:block;\r\n}\r\n\r\n.date{\r\n    padding: 90px 0px 0px;\r\n    display:block;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pdf-forms/khb-instachallan/khb-instachallan.component.css
// module id = ./src/app/pdf-forms/khb-instachallan/khb-instachallan.component.css
// module chunks = main